import { Box, Card, Typography } from "@mui/material";
import ILiquidityPoolDto from "../../../interfaces/liquidity-pool/ILiquidityPoolDto";
import { LiquidityPoolStatusEnum } from "../../../common/enum/liquidity-pool-status-enum";
import { formatPriceToDolar } from "../../../common/utils/number";

interface Props {
  pools: ILiquidityPoolDto[];
  openCount: number;
  closedCount: number;
}

interface SummaryCard {
  label: string;
  value: string | number;
  highlight?: boolean;
}

export default function PoolSummaryCards({ pools, openCount, closedCount }: Props) {
  const outOfRange   = pools.filter(p => p.status === LiquidityPoolStatusEnum.OutOfRange);
  const totalValueUsd = pools.reduce((sum, p) => sum + p.totalValueUsd, 0);
  const totalFeesUsd  = pools.reduce((sum, p) => sum + p.feesPending0Usd + p.feesPending1Usd, 0);

  const cards: SummaryCard[] = [
    { label: 'Posições Abertas',   value: openCount },
    { label: 'Valor Total (USD)',  value: formatPriceToDolar(totalValueUsd) || '0' },
    { label: 'Taxas Pendentes',    value: formatPriceToDolar(totalFeesUsd) || '0' },
    { label: 'Fora do Range',      value: outOfRange.length, highlight: outOfRange.length > 0 },
    { label: 'Posições Fechadas',  value: closedCount },
  ];

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 2 }}>
      {cards.map((card) => (
        <Card key={card.label} sx={{ p: 2, border: '1px solid rgba(255,215,0,0.15)' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {card.label}
          </Typography>
          <Typography
            variant="h5"
            fontWeight={700}
            sx={{ color: card.highlight ? 'warning.main' : 'primary.main', mt: 0.5 }}
          >
            {card.value}
          </Typography>
        </Card>
      ))}
    </Box>
  );
}
